<selection [formGroup]="stepForm"
           class="mbs-wizard_form mbs-nbf-schedule-step">
  <header class="mbs-wizard_form-header mb-4">
    <!-- NO TITLE -->
  </header>

  <!-- LAYOUT START -->

  <div class="mbs-wizard_form-content">
    <mbs-form-group>
      <div [id]="elementSelectors.id.rootDiv"
           class="m-n2 p-1 border rounded"
           [class.border-danger]="invalidScheduleTypeSelection"
           [class.border-white]="!invalidScheduleTypeSelection">
        <ng-container *ngTemplateOutlet="defaultMode"></ng-container>
        <ng-container *ngTemplateOutlet="simpleMode"></ng-container>
        <ng-container *ngTemplateOutlet="advancedMode"></ng-container>
        <ng-container *ngTemplateOutlet="additional"></ng-container>
      </div>
    </mbs-form-group>
  </div>

  <!-- LAYOUT END -->

  <ng-template #defaultMode>
    <div [id]="elementSelectors.id.defaultModeBlock">
      <mbs-alert *ngIf="invalidFFIStorageReason.other || invalidFFIStorageReason.syntheticFull"
                 [attr.data-test-element]="elementSelectors.id.invalidFFIAlert"
                 [type]="mbsPopupType.danger"
                 [icon]="true">
        {{ 'wizards:schedule.defaultMode.invalidFFIStorage' | i18next }}
      </mbs-alert>
      <mbs-alert *ngIf="!isFFIEnabled || isRDMode"
                 [attr.data-test-element]="elementSelectors.id.oldAgentForFFIAlert"
                 [type]="mbsPopupType.danger"
                 [icon]="true">
        {{ 'wizards:ffi_label_min_version_attention' | i18next }}
      </mbs-alert>
      <div class="row">
        <!-- Simple -->
        <div class="col-6">
          <mbs-tile [data]="null"
                    [disabled]="isSimpleDisabled || invalidFFIStorageReason.syntheticFull"
                    [selectable]="true"
                    [selected]="isSimpleMode"
                    [showBody]="false"
                    [headerTemplate]="headerTemplateSimple"
                    [id]="elementSelectors.id.tileSimple"
                    (click)="activateTile('ffi')">
            <ng-template #headerTemplateSimple>
              <div *ngIf="isSimpleDisabled"
                   class="row w-100 pt-3 pb-3"
                   container="body"
                   tooltipClass="tooltip-lg"
                   [placement]="'right'"
                   [ngbTooltip]="simpleDisabledTooltip">
                <ng-container *ngTemplateOutlet="innerHeaderTemplateSimple"></ng-container>
              </div>
              <div *ngIf="!isSimpleDisabled"
                   class="row w-100 pt-3 pb-3">
                <ng-container *ngTemplateOutlet="innerHeaderTemplateSimple"></ng-container>
              </div>
              <ng-template #innerHeaderTemplateSimple>
                <div class="col-11 pl-3">
                  <div class="ml-1">
                    <span class="text-blue m-2 mr-3 fa fa-calendar-o"></span>
                    <strong>{{ 'wizards:schedule.defaultMode.simpleTitle' | i18next }}</strong>
                  </div>
                  <div class="ml-2 mt-1">
                    <div>{{ 'wizards:schedule.defaultMode.simpleDescription1' | i18next }}</div>
                    <div>{{ 'wizards:schedule.defaultMode.simpleDescription2' | i18next }}</div>
                  </div>
                </div>
                <div class="col-1 pl-1">
                  <mbs-radio formControlName="ScheduleType"
                             name="ScheduleType"
                             [disabled]="isSimpleDisabled"
                             [disabledSelf]="isSimpleDisabled"
                             [value]="'ffi'"
                             [label]=""></mbs-radio>
                </div>
              </ng-template>
            </ng-template>
          </mbs-tile>
        </div>
        <!-- Advanced -->
        <div class="col-6">
          <mbs-tile [data]="null"
                    [selectable]="true"
                    [selected]="isAdvancedMode"
                    [showBody]="false"
                    [headerTemplate]="headerTemplate"
                    [id]="elementSelectors.id.tileAdvanced"
                    (click)="activateTile('predefined')">
            <ng-template #headerTemplate>
              <div class="row w-100 pt-3 pb-3">
                <div class="col-11 pl-3">
                  <div class="ml-1">
                    <span class="text-blue m-2 mr-3 fa fa-calendar"></span>
                    <strong>{{ 'wizards:schedule.defaultMode.advancedTitle' | i18next }}</strong>
                  </div>
                  <div class="ml-2 mt-1">
                    <div>{{ 'wizards:schedule.defaultMode.advancedDescription1' | i18next }}</div>
                    <div>{{ 'wizards:schedule.defaultMode.advancedDescription2' | i18next }}</div>
                  </div>
                </div>
                <div class="col-1 pl-1">
                  <mbs-radio formControlName="ScheduleType"
                             name="ScheduleType"
                             [value]="'predefined'"
                             [label]=""></mbs-radio>
                </div>
              </div>
            </ng-template>
          </mbs-tile>
        </div>
      </div>
      <mbs-radio class="mt-3"
                 formControlName="ScheduleTypeNone"
                 [value]="true"
                 [label]="'wizards:schedule.defaultMode.noSchedule' | i18next"
                 [id]="elementSelectors.id.noSchedule"
                 (click)="activateTile('noschedule')"></mbs-radio>
    </div>
  </ng-template>

  <ng-template #simpleMode>
    <div *ngIf="isSimpleMode"
         [id]="elementSelectors.id.simpleModeBlock">
      <mbs-card class="mt-5"
                [size]="'sm'">
        <div class="row m-n1">
          <div class="col">
            <strong class="row ml-n3 pl-1">{{ 'wizards:schedule.simpleMode.backupSchedule' | i18next }}</strong>
            <mbs-button class="row ml-n4 _hover-parent"
                        type="link"
                        [customClasses]="'mw-100 text-wrap text-left multiline-button'"
                        [id]="elementSelectors.id.buttonSimple"
                        (click)="clickDetails('simple')">
              {{ this.scheduleInfo.simple }}
              <span class="_hover-target fa fa-pencil ml-1"></span>
            </mbs-button>
          </div>
        </div>
      </mbs-card>
    </div>
  </ng-template>

  <ng-template #advancedMode>
    <div *ngIf="isAdvancedMode"
         [id]="elementSelectors.id.advancedModeBlock">
      <mbs-card class="mt-5"
                [size]="'sm'">
        <mbs-card-group>
          <div class="row m-n1">
            <div class="col-11">
              <strong class="row ml-n3 pl-1">{{ 'wizards:schedule.advancedMode.incrementalBackupSchedule' | i18next }}</strong>
              <mbs-button class="row ml-n4 _hover-parent"
                          type="link"
                          [disabled]="!stepForm.get('incrementalData').get('enabled').value"
                          [customClasses]="'mw-100 text-wrap text-left multiline-button'"
                          [id]="elementSelectors.id.buttonAdvanced"
                          (click)="clickDetails('advanced')">
                {{ this.scheduleInfo.incremental }}
                <span class="_hover-target fa fa-pencil ml-1"></span>
              </mbs-button>
            </div>
            <div class="col-1 d-flex align-items-center">
              <mbs-switcher [selected]="stepForm.get('incrementalData').get('enabled').value"
                            [disabled]="!stepForm.get('fullBackupData').get('enabled').value"
                            [id]="elementSelectors.id.switcherAdvanced"
                            (change)="incrementalEnabledChangeHandler()">
              </mbs-switcher>
            </div>
          </div>
        </mbs-card-group>
        <mbs-card-group>
          <div class="row m-n1">
            <div class="col-11">
              <strong class="row ml-n3 pl-1">{{ 'wizards:schedule.advancedMode.fullBackupSchedule' | i18next }}</strong>
              <mbs-button class="ml-n4 _hover-parent"
                          type="link"
                          [disabled]="!stepForm.get('fullBackupData').get('enabled').value"
                          [id]="elementSelectors.id.buttonFull"
                          (click)="clickDetails('full')">
                {{ this.scheduleInfo.full }}
                <span class="_hover-target fa fa-pencil ml-1"></span>
              </mbs-button>
            </div>
            <div *ngIf="canOffFull"
                 class="col-1 d-flex align-items-center">
              <mbs-switcher [selected]="stepForm.get('fullBackupData').get('enabled').value"
                            [id]="elementSelectors.id.switcherAdvancedFull"
                            (change)="fullEnabledChangeHandler()">
              </mbs-switcher>
            </div>
          </div>
          <div *ngIf="notConfiguredFull"
               class="row mt-1"
               [id]="elementSelectors.id.alertFull">
            <div class="col-12 p-1">
              <mbs-alert [type]="mbsPopupType.danger"
                         [icon]="true">
                <div>{{ 'wizards:schedule.advancedMode.fullNotConfiguredInfo' | i18next }}</div>
              </mbs-alert>
            </div>
          </div>
        </mbs-card-group>
      </mbs-card>
    </div>
  </ng-template>

  <ng-template #additional>
    <div *ngIf="isSimpleMode || isAdvancedMode || isManualMode"
         [id]="elementSelectors.id.additionalModeBlock"
         class="mt-3">
      <mbs-button type="secondary"
                  (click)="clickAdditional()">
        <i class="fa fa-cog"></i>
        <span>{{ 'wizards:schedule.additionalSettings' | i18next }}</span>
      </mbs-button>
    </div>
  </ng-template>
</selection>

<ng-template #FFIPayAttentionGFS>
  <mbs-alert *ngIf="!isGFSMode"
             [type]="mbsPopupType.warning"
             [icon]="true">
    {{'wizards:ffi_warning_title_prefix'|i18next}}
    <strong>{{'wizards:ffi_label'|i18next}}</strong>
    {{'wizards:ffi_warning_title_postfix'|i18next}}
  </mbs-alert>
  <mbs-alert *ngIf="isGFSMode"
             [type]="mbsPopupType.warning"
             [icon]="true">
    {{'wizards:ffi_warning_title_prefix'|i18next}}
    <strong>{{'wizards:ffi_label'|i18next}}</strong>
    {{'wizards:ffi_warning_title_postfix'|i18next}}.
    {{'wizards:ffi_warning_title_with_gfs_prefix'|i18next}},
    <strong>{{'wizards:ffi_warning_title_with_gfs'|i18next}}</strong>
    {{'wizards:ffi_warning_title_with_gfs_postfix'|i18next}}
  </mbs-alert>
  <strong>{{'shared:notifications.attention'|i18next}}!</strong>
  <ul>
    <li>{{'wizards:ffi_warning_aspect_1'|i18next}}</li>
    <li>{{'wizards:ffi_warning_aspect_2'|i18next}}</li>
  </ul>
  <a *ngIf="ability.can('read', 'HelpMarketing')"
     class="col-3 d-flex align-items-baseline justify-content-end"
     href="/AP/Help/backup/about/backup-format/ffi"
     target="_blank">
    {{'wizards:learn_more_link'|i18next}}
    <span class="ml-1 fa fa-external-link"></span>
  </a>
</ng-template>
